module.exports = __webpack_public_path__ + "img/signup-carousel-second@2x.43569e47.png";